import { Entry } from 'contentful';

import { FReadOnlyRow } from './readOnlyRow.factory';

export const FCollectionGeneric = (data: Entry<any>): any => {
  const { title, collection } = data.fields;
  return {
    title,
    collection: collection.map(FReadOnlyRow)
  };
};
